import client from '@/plugins/axios.js'

export default  {
    getAllScores(){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).get('/api/dealer/pointsSummary')
                .then((res)=>{
                    resolve(res.data.data)
                })
                .catch((err)=>{
                    reject(err)
                })
        });
    },
    getTeammemberScores(payload){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).get('/api/dealer/scorelogForTeammember/'+payload.memberid)
                .then((res)=>{
                    resolve(res.data.data)
                })
                .catch((err)=>{
          reject(err)
                })
        });
    },
    
    getTeammemberDealer(payload){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).get('/api/dealer/dealerobjectForTeammember/'+payload.memberid)
                .then((res)=>{
                    resolve(res.data.data)
                })
                .catch((err)=>{
                    reject(err)
                })
        });
    },
    
    getTopTen(payload){
      return new Promise((resolve,reject)=>{
        
        client({requiresAuth:true}).get('/api/result/topTenForWeek/'+payload.week+'/mode/'+payload.mode)
          .then((res)=>{
            resolve(res.data.data)
          })
          .catch((err)=>{
            reject(err)
          })
      });
    },

    getBestscores(payload){
      return new Promise((resolve,reject)=>{
        client({requiresAuth:true}).get('/api/result/bestscoresForWeek/'+payload.week)
          .then((res)=>{
            resolve(res.data.data)
          })
          .catch((err)=>{
            reject(err)
          })
      });
    },
  
    getTenKscores(payload){
      return new Promise((resolve,reject)=>{
        client({requiresAuth:true}).get('/api/result/tenKForWeek/'+payload.week)
          .then((res)=>{
            resolve(res.data.data)
          })
          .catch((err)=>{
            reject(err)
          })
      });
    },

  getQualificationscores(){
      return new Promise((resolve,reject)=>{
        client({requiresAuth:true}).get('/api/result/qualification')
          .then((res)=>{
            resolve(res.data)
          })
          .catch((err)=>{
            reject(err)
          })
      });
    }



  
    
}
